module.exports = __webpack_public_path__ + "img/ribbon-bronze.16f9b8b2.svg";